import { SegmentedControl } from '@neo4j-ndl/react';
import type { TierConfigs } from '@nx/state';

import { isMultiProductProject } from '../entities/helpers';
import type { Product } from '../entities/model';

export const ProductSelection = ({
  tierConfigs,
  handleProductSelect,
  product,
}: {
  tierConfigs: TierConfigs;
  handleProductSelect: (product: Product) => void;
  product: Product;
}) => {
  if (!isMultiProductProject(tierConfigs)) {
    return null;
  }

  return (
    <SegmentedControl onChange={handleProductSelect} selected={product}>
      <SegmentedControl.Item
        value="AuraDB"
        htmlAttributes={{
          'aria-label': 'View Aura Database plans',
        }}
      >
        AuraDB
      </SegmentedControl.Item>
      <SegmentedControl.Item
        value="AuraDS"
        htmlAttributes={{
          'aria-label': 'View Aura Data Science plans',
        }}
      >
        AuraDS
      </SegmentedControl.Item>
    </SegmentedControl>
  );
};
